import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { SupportedLanguagesCodes } from '@app/shared/enums/supported-language-codes.enum';
import { SimpleFlowDetectionService } from '@app/shared/services/simple-flow-detection/simple-flow-detection.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnDestroy {

  Languages = SupportedLanguagesCodes;
  currentLang: string;
  isRouteBySimpleFlow$ = this.simpleFlowService.isSimpleFlow$();
  private masterSubscription = new Subscription();

  constructor(private translate: TranslateService, private simpleFlowService: SimpleFlowDetectionService) {
    this.currentLang = this.translate.currentLang;
    const langChangeSub = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.currentLang = event.lang;
      });
    this.masterSubscription.add(langChangeSub);
  }

  ngOnDestroy(): void {
    this.masterSubscription.unsubscribe();
  }

  currentLangIsEn(): boolean {
    return this.translate.currentLang === SupportedLanguagesCodes.English;
  }

  currentLangIsNl(): boolean {
    return this.translate.currentLang === SupportedLanguagesCodes.Dutch;
  }

  useLanguage(language: SupportedLanguagesCodes): void {
    this.translate.use(language);
  }

}
